export const useCommentTitleGeneration = (
    reportId?: string,
    reportRowNumber?: number,
    reportRowDescription?: string,
    reportColumnDesciption?: string
) => {
    const defaultTitle = 'Comment';

    let cellLevelTitle = defaultTitle;
    if (reportRowDescription) {
        cellLevelTitle = reportRowDescription!.trim();
        if (reportColumnDesciption) {
            cellLevelTitle = `${cellLevelTitle} | ${reportColumnDesciption}`;
        }
    }

    const newConversationTitle = reportRowNumber ? cellLevelTitle : reportId ? 'General' : defaultTitle;

    return { newConversationTitle };
};
